import React, { useContext } from "react";
import { CartContext } from "../../Componinets/Context/CartContext";
import { FaTrashAlt } from "react-icons/fa";
import "./Cart.css";
import PageTransion from "../../Componinets/PageTransion";

function Cart() {
  let { cartitem, increasequantity, Decreasequantity, removefromcart } =
    useContext(CartContext);
  console.log(cartitem);

  let total = cartitem.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  return (
    <PageTransion>
      <div className="Checkout">
        <div className="OrderSummary">
          <h1>Order Summary</h1>
          <div className="items">
            {cartitem.length === 0 ? (
              <p>Your Cart is Empty</p>
            ) : (
              cartitem.map((item, index) => (
                <div className="item_cart" key={index}>
                  <div className="image-name">
                    <div className="item_img">
                      <img src={item.images[0]} alt="" />
                    </div>
                    <div className="content">
                      <h4>{item.title}</h4>
                      <p className="price_item">${item.price}</p>

                      <div className="quantity_control">
                        <button onClick={() => Decreasequantity(item.id)}>
                          -
                        </button>
                        <span className="quntity">{item.quantity}</span>
                        <button onClick={() => increasequantity(item.id)}>
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => removefromcart(item.id)}
                    className="delete_item"
                  >
                    <FaTrashAlt />
                  </button>
                </div>
              ))
            )}
          </div>

          <div className="button_summory">
            <div className="shop_tabel">
              <p>Total:</p>
              <span className="total_Checkout">${total.toFixed(2)}</span>
            </div>
            <div className="button_div">
              <button type="submit">Place Order</button>
            </div>
          </div>
        </div>
      </div>
    </PageTransion>
  );
}

export default Cart;
